import { render, staticRenderFns } from "./TheActiveEgiftOrders.vue?vue&type=template&id=17afb9b2&scoped=true"
import script from "./TheActiveEgiftOrders.vue?vue&type=script&lang=js"
export * from "./TheActiveEgiftOrders.vue?vue&type=script&lang=js"
import style0 from "./TheActiveEgiftOrders.vue?vue&type=style&index=0&id=17afb9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17afb9b2",
  null
  
)

export default component.exports